<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            :start-validations="validations.periodo.date.start"
                            :end-validations="validations.periodo.date.end"
                            :max-date="maxDate"
                            :min-date="minDate"
                            v-model="model.periodo.date"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-time-picker
                            :disabled="!isPeriodoFill"
                            label="Hora de"
                            v-model="model.periodo.time.start"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-time-picker
                            :disabled="!isPeriodoFill"
                            label="Até"
                            v-model="model.periodo.time.end"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="diaSemanaChange()"
                            :options="form.diasSemana"
                            default-option-text="Todos"
                            label="Dia da semana"
                            show-default-option
                            text-field="descricao"
                            v-model="model.diaSemana"
                            value-field="valor"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="unidadeChange()"
                            :options="form.unidades"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="localAtendimentoChange()"
                            :options="form.locaisAtendimento"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.localAtendimentoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="classificacaoRiscoChange()"
                            :options="form.classificacoesRisco"
                            defaultOptionText="Todas"
                            label="Classificação de risco"
                            show-default-option
                            text-field="nome"
                            v-model="model.classificacaoRiscoId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="desfechoChange()"
                            :options="form.desfechos"
                            default-option-text="Todos"
                            label="Desfecho"
                            show-default-option
                            text-field="nome"
                            v-model="model.desfechoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="ocupacaoChange()"
                            :options="form.ocupacoes"
                            default-option-text="Todas"
                            label="CBO"
                            show-default-option
                            text-field="nome"
                            v-model="model.ocupacaoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="profissionalChange()"
                            :options="form.profissionais"
                            default-option-text="Todos"
                            label="Profissional"
                            show-default-option
                            text-field="nome"
                            v-model="model.profissionalId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="statusChange()"
                            :options="status"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            text-field="descricao"
                            v-model="model.status"
                            value-field="valor"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="cidChange()"
                            :options="form.cids"
                            default-option-text="Todos"
                            label="Cid"
                            show-default-option
                            text-field="nome"
                            v-model="model.cidId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="1">
                        <rkm-form-input
                            :disabled="!isPeriodoFill"
                            :validations="validations.idadeDe"
                            @blur="blurIdade()"
                            label="Idade de"
                            type="number"
                            v-model="model.idadeDe"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-input
                            :disabled="!isPeriodoFill"
                            :validations="validations.idadeAte"
                            @blur="blurIdade()"
                            label="Até"
                            type="number"
                            v-model="model.idadeAte"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input-autocomplete
                            :disabled="!isPeriodoFill"
                            :repository="repositories.relatorioAtendimento"
                            :request-query-string-params="getFilter()"
                            :search-fields="[
                                { key: 'cadastro_cidadao.nome', searchable: true }
                            ]"
                            label="Paciente"
                            v-model="model.paciente"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            :disabled="!isPeriodoFill || (model.paciente && model.paciente.prontuario != null)"
                            @blur="blurProntuario()"
                            :validations="validations.prontuario"
                            label="Prontuário"
                            v-model="model.prontuario"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="sexoChange()"
                            :options="form.sexos"
                            default-option-text="Todos"
                            label="Sexo"
                            show-default-option
                            text-field="descricao"
                            v-model="model.sexoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            @change="classificacaoPacienteChange()"
                            :options="form.classificacoesPaciente"
                            default-option-text="Todas"
                            label="Classificação do paciente"
                            show-default-option
                            text-field="descricao"
                            v-model="model.classificacaoPacienteId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="form.unidadesReferencia"
                            default-option-text="Todas"
                            label="Unidade referência"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeReferenciaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-input
                            type="number"
                            label="FAA"
                            v-model="model.faa"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="optionsFatorRisco"
                            default-option-text="Todos"
                            label="Câncer"
                            show-default-option
                            text-field="text"
                            v-model="model.fatorRiscoCancer"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="optionsFatorRisco"
                            default-option-text="Todos"
                            label="Diabetes"
                            show-default-option
                            text-field="text"
                            v-model="model.fatorRiscoDiabetes"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="optionsFatorRisco"
                            default-option-text="Todos"
                            label="Etilismo"
                            show-default-option
                            text-field="text"
                            v-model="model.fatorRiscoEtilismo"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="optionsFatorRisco"
                            default-option-text="Todos"
                            label="Gestante"
                            show-default-option
                            text-field="text"
                            v-model="model.fatorRiscoGestante"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="optionsFatorRisco"
                            default-option-text="Todos"
                            label="Hipertensão"
                            show-default-option
                            text-field="text"
                            v-model="model.fatorRiscoHipertensao"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="optionsFatorRisco"
                            default-option-text="Todos"
                            label="Obesidade"
                            show-default-option
                            text-field="text"
                            v-model="model.fatorRiscoObesidade"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="optionsFatorRisco"
                            default-option-text="Todos"
                            label="Radioterapia"
                            show-default-option
                            text-field="text"
                            v-model="model.fatorRiscoRadioterapia"
                            value-field="value"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="optionsFatorRisco"
                            default-option-text="Todos"
                            label="Perfil sanguíneo alterado"
                            show-default-option
                            text-field="text"
                            v-model="model.fatorRiscoPerfilSanguineoAlterado"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col cols="1">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="optionsFatorRisco"
                            default-option-text="Todos"
                            label="Tabagismo"
                            show-default-option
                            text-field="text"
                            v-model="model.fatorRiscoTabagismo"
                            value-field="value"
                        />
                    </rkm-col>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="optionsFatorRisco"
                            default-option-text="Todos"
                            label="Uso de medicamentos antineoplásicos ou imunossupressores"
                            show-default-option
                            text-field="text"
                            v-model="model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="optionsFatorRisco"
                            default-option-text="Todos"
                            label="Outro"
                            show-default-option
                            text-field="text"
                            v-model="model.fatorRiscoOutro"
                            value-field="value"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-0 text-nowrap">
                        <rkm-button
                            :disabled="!isPeriodoFill && !model.faa"
                            :label="false"
                            @click="handleBuscar()"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!isPeriodoFill && !model.faa"
                            :label="false"
                            @click="limpar()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            title="Totais"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col cols="3">
                    Total de atendimentos realizados
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalAtendimentos }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="3">
                    Total de pacientes
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalPacientes }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="3">
                    Total de evasões
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalEvasao }}
                        </strong>
                    </rkm-alert>
                </rkm-col>

                <rkm-col cols="3">
                    Total de registros de atendimentos (FAA)
                    <rkm-alert color="secondary">
                        <strong>
                            {{ totalFaa }}
                        </strong>
                    </rkm-alert>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    no-caret
                    small
                    title="Colunas"
                    cols="1"
                    v-rkm-tooltip.hover
                    menu-class="auto-scroll"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="handleTodosClick"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedColumns"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="imprimir()"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportar()"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                v-if="form"
                :fields="fields"
                :items="items"
                :sort-compare="sortCompare"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                @sort-changed="onSortChanged"
            >
                <template v-slot:cell(procedimentos)="row">
                    <div
                        :class="row.item.procedimentos.length == 1 ? null : 'border-bottom'"
                        v-for="(procedimento, idx) in row.item.procedimentos"
                        :key="idx"
                    >
                        {{ procedimento }}
                    </div>

                </template>

                <template v-slot:cell(cids)="row">

                    <div v-for="(cid, idx) in row.item.cids" :key="idx">
                        {{ cid }}
                    </div>

                </template>
                <template v-slot:cell(cidsCodigo)="row">

                    <div v-for="(cid, idx) in row.item.cidsCodigo" :key="idx">
                        {{ cid }}
                    </div>

                </template>
            </rkm-table>
        </rkm-area>

        <ModalPreferenciaImpressao ref="ModalPreferenciaImpressao" @orientation="updateOrientation"/>
    </div>
</template>

<script>
// Components.
import ModalPreferenciaImpressao from '@/components/geral/impressao/Modal'

// Mixins.
import { repository, error, data, object, stringCase, debounce } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Moment.
import moment from 'moment'

// Filters
import formatsFilter from '@/filters/formats'

export default {
    components:{ ModalPreferenciaImpressao },
    computed: {
        minDate() {

            const end = this.model.periodo.date.end
            const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY')

            if (end != null) {

                return moment(end).subtract(31, 'days').format('DD/MM/YYYY')
            }

            if (this.model.periodo.date.start == null) {

                return null
            }

            return dataAtual.subtract(31, 'days').format('DD/MM/YYYY')
        },
        maxDate() {

            const start = this.model.periodo.date.start
            const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY')

            if (start != null) {

                const end = moment(start).add(30, 'days')

                if (end.isBefore(dataAtual)) {

                    return end.format('DD/MM/YYYY')
                }
            }

            return dataAtual.format('DD/MM/YYYY')
        },
        fields() {
            return this.columns.filter(column => (column.fixed || false) || this.selectedColumns.includes(column.key))
        },
        optionalColumns() {
            return this.columns.filter(column => !(column.fixed || false))
        },
        validations() {

            let idadeAteMinValue = 0

            if (this.model.idadeDe != null && this.model.idadeDe != '') {

                idadeAteMinValue = this.model.idadeDe
            }

            return {
                periodo: {
                    date: {
                        start: { required: !this.model.faa },
                        end: { required: !this.model.faa },
                    },
                },
                idadeDe: { min: 0, min_value: 0 },
                idadeAte: { min: 0, min_value: idadeAteMinValue},
                prontuario: { max: 6 },
            }
        },
        isPeriodoFill() {

            return this.model && this.model.periodo.date.start != null && this.model.periodo.date.end != null
        },
        status() {

            return this.form && this.form.status ? this.sortStatus() : []
        }
    },
    created() {
        this.repositories = {
            relatorioAtendimento: this.getConectaSusRepository('prontoAtendimento.relatorioAtendimento'),
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento'),
            export: this.getConectaSusRepository('exportacao.prontoAtendimento'),
        }

        this.load()
    },
    data: () => ({
        items: [],
        totalAtendimentos: 0,
        totalEvasao: 0,
        totalFaa: 0,
        totalPacientes: 0,
        model: null,
        form: null,
        orientation: false,
        additionals: null,
        indeterminate: false,
        filterDefault: {},
        selectedAll: false,
        selectedColumns: [],
        optionsFatorRisco: [
            { value: 1, text: 'Sim' },
            { value: 0, text: 'Não' },
        ],
        columns: [
            {
                key: 'atendidoEm',
                label: 'Data',
                sortable: true,
                filterByFormatted: true,
                formatter: value => formatsFilter.formatDateTime(value),
                fixed: true
            },
            { key: 'diaSemana', label: 'Dia da semana', sortable: true, fixed: false },
            { key: 'numeroFaa', label: 'FAA', sortable: true, fixed: false },
            { key: 'prontuario', label: 'Prontuário', sortable: true, fixed: true },
            { key: 'nomePaciente', label: 'Paciente', sortable: true, fixed: true },
            { key: 'sexoDescricao', label: 'Sexo', sortable: true, fixed: false },
            { key: 'idade', label: 'Idade', sortable: true, fixed: false },
            {
                key: 'dataNascimento',
                label: 'Data de nascimento',
                sortable: true,
                filterByFormatted: true,
                formatter: value => formatsFilter.formatDate(value),
                fixed: false
            },
            { key: 'endereco', label: 'Endereço', sortable: true, fixed: false },
            { key: 'telefones', label: 'Telefone(s)', sortable: true, fixed: false },
            { key: 'unidadeReferencia', label: 'Unidade referência', sortable: true, fixed: false },
            { key: 'classificacaoPaciente', label: 'Classificação do paciente', sortable: true, fixed: false },
            { key: 'nomeUnidade', label: 'Unidade', sortable: true, fixed: false },
            { key: 'localAtendimento', label: 'Local de atendimento', sortable: true, fixed: false },
            { key: 'motivoAtendimento', label: 'Motivo do atendimento', sortable: true, fixed: false },
            { key: 'classificacaoRisco', label: 'Classificação de risco', sortable: true, fixed: false },
            { key: 'nomeDesfecho', label: 'Desfecho', sortable: true, fixed: false },
            { key: 'status', label: 'Status FAA', sortable: true, fixed: false },
            { key: 'cidsCodigo', label: 'Código CID', sortable: true, fixed: false },
            { key: 'cids', label: 'CID', sortable: true, fixed: false },
            { key: 'procedimentos', label: 'Procedimento(s)', sortable: true, fixed: false },
            { key: 'profissional', label: 'Profissional', sortable: true, fixed: false },
            { key: 'ocupacaoCodigo', label: 'Código do CBO', sortable: true, fixed: false },
            { key: 'ocupacao', label: 'CBO', sortable: true, fixed: false },
        ],
        selectedCols: [],
        debounceDelay: 400,
        sortBy: 'atendidoEm',
        sortDesc: false,
    }),
    methods: {
        ...formatsFilter,
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'atendidoEm') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        load() {
            this.setLoading()

            this.repositories.relatorioAtendimento.list()
                .then(({ data }) => {

                    this.model = this.clone(data.model)
                    this.form = this.clone(data.form)
                    this.additionals = this.clone(data.additionals)

                    this.filterDefault = {
                        form: this.clone(this.form),
                        model: this.clone(this.model)
                    }

                    this.addPeriodoWatch()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addPeriodoWatch() {

            this.$watch('model.periodo.date', {
                deep: true,
                handler() {

                    this.model.faa = null

                    this.model.periodo.time.start = null
                    this.model.periodo.time.end = null
                    this.model.diaSemana = null
                    this.model.unidadeId = null
                    this.model.localAtendimentoId = null
                    this.model.classificacaoRiscoId = null
                    this.model.desfechoId = null
                    this.model.ocupacaoId = null
                    this.model.profissionalId = null
                    this.model.status = null
                    this.model.cidId = null
                    this.model.paciente = null
                    this.model.sexoId = null
                    this.model.classificacaoPacienteId = null
                    this.model.unidadeReferenciaId = null
                    this.model.idadeDe = null
                    this.model.idadeAte = null
                    this.model.fatorRiscoCancer = null
                    this.model.fatorRiscoDiabetes = null
                    this.model.fatorRiscoEtilismo = null
                    this.model.fatorRiscoGestante = null
                    this.model.fatorRiscoHipertensao = null
                    this.model.fatorRiscoObesidade = null
                    this.model.fatorRiscoPerfilSanguineoAlterado = null
                    this.model.fatorRiscoRadioterapia = null
                    this.model.fatorRiscoTabagismo = null
                    this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
                    this.model.fatorRiscoOutro = null

                    this.form.diasSemana = []
                    this.form.unidades = []
                    this.form.locaisAtendimento = []
                    this.form.classificacoesRisco = []
                    this.form.desfechos = []
                    this.form.ocupacoes = []
                    this.form.profissionais = []
                    this.form.status = []
                    this.form.cids = []

                    this.form.sexos = []
                    this.form.classificacoesPaciente = []
                    this.form.unidadesReferencia = []

                    const filter = this.getFilter()

                    if (filter) {

                        this.setLoading()

                        this.repositories.relatorioAtendimento.list(filter)
                            .then(({ data }) => {

                                this.form = this.clone(data.form);
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        peridoTimeChange() {

            this.model.diaSemana = null
            this.model.unidadeId = null
            this.model.localAtendimentoId = null
            this.model.classificacaoRiscoId = null
            this.model.desfechoId = null
            this.model.ocupacaoId = null
            this.model.profissionalId = null
            this.model.status = null
            this.model.cidId = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.diasSemana = []
            this.form.unidades = []
            this.form.locaisAtendimento = []
            this.form.classificacoesRisco = []
            this.form.desfechos = []
            this.form.ocupacoes = []
            this.form.profissionais = []
            this.form.status = []
            this.form.cids = []

            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.list(filter)
                    .then(({ data }) => {

                        this.form = this.clone(data.form);
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        diaSemanaChange() {

            this.model.unidadeId = null
            this.model.localAtendimentoId = null
            this.model.classificacaoRiscoId = null
            this.model.desfechoId = null
            this.model.ocupacaoId = null
            this.model.profissionalId = null
            this.model.status = null
            this.model.cidId = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.unidades = []
            this.form.locaisAtendimento = []
            this.form.classificacoesRisco = []
            this.form.desfechos = []
            this.form.ocupacoes = []
            this.form.profissionais = []
            this.form.status = []
            this.form.cids = []
            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorDiaSemana(filter)
                    .then(({ data }) => {

                        this.form.unidades = this.clone(data.unidades)
                        this.form.locaisAtendimento = this.clone(data.locaisAtendimento)
                        this.form.classificacoesRisco = this.clone(data.classificacoesRisco)
                        this.form.desfechos = this.clone(data.desfechos)
                        this.form.ocupacoes = this.clone(data.ocupacoes)
                        this.form.profissionais = this.clone(data.profissionais)
                        this.form.status = this.clone(data.status)
                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        unidadeChange() {

            this.model.localAtendimentoId = null
            this.model.classificacaoRiscoId = null
            this.model.desfechoId = null
            this.model.ocupacaoId = null
            this.model.profissionalId = null
            this.model.status = null
            this.model.cidId = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.locaisAtendimento = []
            this.form.classificacoesRisco = []
            this.form.desfechos = []
            this.form.ocupacoes = []
            this.form.profissionais = []
            this.form.status = []
            this.form.cids = []
            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorUnidade(filter)
                    .then(({ data }) => {

                        this.form.locaisAtendimento = this.clone(data.locaisAtendimento)
                        this.form.classificacoesRisco = this.clone(data.classificacoesRisco)
                        this.form.desfechos = this.clone(data.desfechos)
                        this.form.ocupacoes = this.clone(data.ocupacoes)
                        this.form.profissionais = this.clone(data.profissionais)
                        this.form.status = this.clone(data.status)
                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        localAtendimentoChange() {

            this.model.classificacaoRiscoId = null
            this.model.desfechoId = null
            this.model.ocupacaoId = null
            this.model.profissionalId = null
            this.model.status = null
            this.model.cidId = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.classificacoesRisco = []
            this.form.desfechos = []
            this.form.ocupacoes = []
            this.form.profissionais = []
            this.form.status = []
            this.form.cids = []
            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorLocalAtendimento(filter)
                    .then(({ data }) => {

                        this.form.classificacoesRisco = this.clone(data.classificacoesRisco)
                        this.form.desfechos = this.clone(data.desfechos)
                        this.form.ocupacoes = this.clone(data.ocupacoes)
                        this.form.profissionais = this.clone(data.profissionais)
                        this.form.status = this.clone(data.status)
                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        classificacaoRiscoChange() {

            this.model.desfechoId = null
            this.model.ocupacaoId = null
            this.model.profissionalId = null
            this.model.status = null
            this.model.cidId = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.desfechos = []
            this.form.ocupacoes = []
            this.form.profissionais = []
            this.form.status = []
            this.form.cids = []
            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorClassificacaoRisco(filter)
                    .then(({ data }) => {

                        this.form.desfechos = this.clone(data.desfechos)
                        this.form.ocupacoes = this.clone(data.ocupacoes)
                        this.form.profissionais = this.clone(data.profissionais)
                        this.form.status = this.clone(data.status)
                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        desfechoChange() {

            this.model.ocupacaoId = null
            this.model.profissionalId = null
            this.model.status = null
            this.model.cidId = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.ocupacoes = []
            this.form.profissionais = []
            this.form.status = []
            this.form.cids = []
            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorDesfecho(filter)
                    .then(({ data }) => {

                        this.form.ocupacoes = this.clone(data.ocupacoes)
                        this.form.profissionais = this.clone(data.profissionais)
                        this.form.status = this.clone(data.status)
                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        ocupacaoChange() {

            this.model.profissionalId = null
            this.model.status = null
            this.model.cidId = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.profissionais = []
            this.form.status = []
            this.form.cids = []
            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorOcupacao(filter)
                    .then(({ data }) => {

                        this.form.profissionais = this.clone(data.profissionais)
                        this.form.status = this.clone(data.status)
                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        profissionalChange() {

            this.model.status = null
            this.model.cidId = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.status = []
            this.form.cids = []
            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorProfissional(filter)
                    .then(({ data }) => {

                        this.form.status = this.clone(data.status)
                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        statusChange() {

            this.model.cidId = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.cids = []
            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorStatus(filter)
                    .then(({ data }) => {

                        this.form.cids = this.clone(data.cids)
                        this.form.sexos = this.clone(data.sexos)
                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        cidChange() {

            this.model.idadeDe = null
            this.model.idadeAte = null
            this.model.paciente = null
            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorCid(filter)
                    .then(({ data }) => {

                        this.form.sexos = this.clone(data.sexos)
                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        blurIdade() {

            this.model.paciente = null
            this.model.paciente_id = null
            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorCid(filter)
                    .then(({ data }) => {

                        this.form.sexos = this.clone(data.sexos)
                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        blurProntuario() {

            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorCid(filter)
                    .then(({ data }) => {

                        this.form.sexos = this.clone(data.sexos)
                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.form.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        onSortChanged(context) {

            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        sexoChange() {

            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorSexo(filter)
                    .then(({ data }) => {

                        this.form.classificacoesPaciente = this.clone(data.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        classificacaoPacienteChange() {

            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.filtragemPorClassificacaoPaciente(filter)
                    .then(({ data }) => {

                        this.form.unidadesReferencia = this.clone(data.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleBuscar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.items = []

                    this.repositories.relatorioAtendimento.index(this.getFilter())
                        .then(({ data }) => {

                            this.items = data.atendimentos
                            this.totalAtendimentos = data.totalAtendimentos
                            this.totalEvasao = data.totalEvasao
                            this.totalFaa = data.totalFaa
                            this.totalPacientes = data.totalPacientes
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        imprimir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.$refs.ModalPreferenciaImpressao.open();
                    this.$refs.ModalPreferenciaImpressao.$once('completed', () => {

                        this.setLoading()

                        const filter = this.getFilterExportPrint()

                        this.repositories.impressao.relatorioAtendimento(filter)
                            .then(response => {

                                this.download(response)
                            })
                            .finally(() => this.unsetLoading())
                    })
                })
        },
        exportar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const filter = this.getFilterExportPrint()

                    this.repositories.export.exportAtendimento(filter)
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        updateOrientation(value) {
            this.orientation = value;
        },
        getFilterExportPrint() {

            const filter = this.getFilter()
            const $this = this

            const cols = this.fields.map(field => ({
                ...field,
                key: $this.camelToSnake(field.key)
            }));

            filter.columns = cols
            filter.orientation = this.orientation

            const unidade = this.form.unidades.find(f => f.id === this.model.unidadeId)
            filter.unidade = unidade ? unidade.nomeFantasia : 'Todas'

            const localAtendimento = this.form.locaisAtendimento.find(f => f.id === this.model.localAtendimentoId)
            filter.local_atendimento = localAtendimento ? localAtendimento.nome : 'Todos'

            const diaSemana = this.form.diasSemana.find(f => f.valor === this.model.diaSemana)
            filter.dia_semana_descricao = diaSemana ? diaSemana.descricao : 'Todos'

            const classificacaoRisco = this.form.classificacoesRisco.find(f => f.id === this.model.classificacaoRiscoId)
            filter.classificacao_risco = classificacaoRisco ? classificacaoRisco.nome : 'Todas'

            const desfecho = this.form.desfechos.find(f => f.id === this.model.desfechoId)
            filter.desfecho = desfecho ? desfecho.nome : 'Todos'

            const ocupacao = this.form.ocupacoes.find(f => f.id === this.model.ocupacaoId)
            filter.ocupacao = ocupacao ? ocupacao.nome : 'Todos'

            const profissional = this.form.profissionais.find(f => f.id === this.model.profissionalId)
            filter.profissional = profissional ? profissional.nome : 'Todos'

            const status = this.form.status.find(f => f.valor === this.model.status)
            filter.status_descricao = status ? status.descricao : 'Todos'

            const cid = this.form.cids.find(f => f.id === this.model.cidId)
            filter.cid = cid ? cid.nome : 'Todos'

            filter.paciente = this.model.paciente ? this.model.paciente.nome : 'Todos'

            const sexo = this.form.sexos.find(f => f.id === this.model.sexoId)
            filter.sexo = sexo ? sexo.descricao : 'Todos'

            const classficacaoPaciente = this.form.classificacoesPaciente.find(f => f.id === this.model.classificacaoPacienteId)
            filter.classificacao_paciente = classficacaoPaciente ? classficacaoPaciente.descricao : 'Todas'

            const unidadeReferencia = this.form.unidadesReferencia.find(f => f.id === this.model.unidadeReferenciaId)
            filter.unidade_referencia = unidadeReferencia ? unidadeReferencia.nomeFantasia : 'Todas'

            const cancer = this.optionsFatorRisco.find(f => f.value === this.model.fatorRiscoCancer)
            filter.fator_risco_cancer_text = cancer ? cancer.text : 'Todos'

            const diabetes = this.optionsFatorRisco.find(f => f.value === this.model.fatorRiscoDiabetes)
            filter.fator_risco_diabetes_text = diabetes ? diabetes.text : 'Todos'

            const etilismo = this.optionsFatorRisco.find(f => f.value === this.model.fatorRiscoEtilismo)
            filter.fator_risco_etilismo_text = etilismo ? etilismo.text : 'Todos'

            const gestante = this.optionsFatorRisco.find(f => f.value === this.model.fatorRiscoGestante)
            filter.fator_risco_gestante_text = gestante ? gestante.text : 'Todos'

            const hipertensao = this.optionsFatorRisco.find(f => f.value === this.model.fatorRiscoHipertensao)
            filter.fator_risco_hipertensao_text = hipertensao ? hipertensao.text : 'Todos'

            const obesidade = this.optionsFatorRisco.find(f => f.value === this.model.fatorRiscoObesidade)
            filter.fator_risco_obesidade_text = obesidade ? obesidade.text : 'Todos'

            const perfilSanguineoAlterado = this.optionsFatorRisco.find(f => f.value === this.model.fatorRiscoPerfilSanguineoAlterado)
            filter.fator_risco_perfil_sanguineo_alterado_text = perfilSanguineoAlterado ? perfilSanguineoAlterado.text : 'Todos'

            const radioterapia = this.optionsFatorRisco.find(f => f.value === this.model.fatorRiscoRadioterapia)
            filter.fator_risco_radioterapia_text = radioterapia ? radioterapia.text : 'Todos'

            const tabagismo = this.optionsFatorRisco.find(f => f.value === this.model.fatorRiscoTabagismo)
            filter.fator_risco_tabagismo_text = tabagismo ? tabagismo.text : 'Todos'

            const usoMedicamentosAntineoplasicosImunossupressores = this.optionsFatorRisco
                .find(f => f.value === this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores)
            filter.fator_risco_uso_medicamentos_antineoplasicos_imunossupressores_text =
                usoMedicamentosAntineoplasicosImunossupressores
                    ? usoMedicamentosAntineoplasicosImunossupressores.text
                    : 'Todos'

            const outro = this.optionsFatorRisco.find(f => f.value === this.model.fatorRiscoOutro)
            filter.fator_risco_outro_text = outro ? outro.text : 'Todos'

            return filter
        },
        getFilter() {

            if (this.isPeriodoFill || this.model.faa) {

                const filter = this.clone(this.model)

                filter.sortBy = this.sortBy ? this.camelToSnake(this.sortBy) : null
                filter.sortDesc = this.sortDesc
                filter.pacienteId = filter.paciente && filter.paciente.id
                filter.periodo.date.start = this.getFormatedDate(filter.periodo.date.start, 'DD/MM/YYYY')
                filter.periodo.date.end = this.getFormatedDate(filter.periodo.date.end, 'DD/MM/YYYY')

                return this.camelObjectKeysToSnakeRecursive(filter)
            }

            return null
        },
        download(response) {

            const content = new Blob([response.data], {type: response.headers['content-type']})
            const url = URL.createObjectURL(content)
            const link = document.createElement('a')

            link.href = url
            link.target = '_blank'
            link.click()
            link.remove()
        },
        limpar() {

            this.form = this.clone(this.filterDefault.form)
            this.model = this.clone(this.filterDefault.model)
            this.$refs.RkmForm.resetValidator()
        },
        sortStatus() {

            return this.form.status.sort((a,b) =>
                (a.descricao > b.descricao) ? 1 : ((b.descricao > a.descricao) ? -1 : 0));
        },
        handleTodosClick(selected) {
            this.selectedColumns = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [ repository, error, data, object, stringCase, debounce ],
    watch: {
        selectedColumns(value) {
            this.indeterminate = value.length > 0 && value.length != this.optionalColumns.length
            this.selectedAll = value.length > 0 && value.length == this.optionalColumns.length
        },
        'model.paciente' : function () {

            this.model.prontuario = this.model.paciente ? this.model.paciente.prontuario : null

            this.model.sexoId = null
            this.model.classificacaoPacienteId = null
            this.model.unidadeReferenciaId = null
            this.model.fatorRiscoCancer = null
            this.model.fatorRiscoDiabetes = null
            this.model.fatorRiscoEtilismo = null
            this.model.fatorRiscoGestante = null
            this.model.fatorRiscoHipertensao = null
            this.model.fatorRiscoObesidade = null
            this.model.fatorRiscoPerfilSanguineoAlterado = null
            this.model.fatorRiscoRadioterapia = null
            this.model.fatorRiscoTabagismo = null
            this.model.fatorRiscoUsoMedicamentosAntineoplasicosImunossupressores = null
            this.model.fatorRiscoOutro = null

            this.form.sexos = []
            this.form.classificacoesPaciente = []
            this.form.unidadesReferencia = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioAtendimento.list(filter)
                    .then(({ data }) => {

                        this.form = this.clone(data.form);

                        this.form.sexos = this.clone(data.form.sexos)
                        this.form.classificacoesPaciente = this.clone(data.form.classificacoesPaciente)
                        this.form.unidadesReferencia = this.clone(data.form.unidadesReferencia)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        'model.faa': function (newValue) {

            if (newValue) {

                this.model.periodo.date.start = null
                this.model.periodo.date.end = null
            }
        },
        'model.periodo.time.start': function (newValue) {
            if (newValue) {
                this.peridoTimeChange()
            }
        },
        'model.periodo.time.end': function (newValue) {
            if (newValue) {
                this.peridoTimeChange()
            }
        },
    }
}
</script>

<style scoped>
    .total {
        text-align: right;
        font-weight: bold;
    }

    .dropdown >>> .auto-scroll {
        max-height: 400px;
        overflow-y: auto;
        width: 400px;
    }

    .border-bottom {
        border-bottom: 1px solid rgb(27, 11, 11);
    }
</style>